(function () {
  'use strict'

  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers').controller('EmailsController', emails)

  emails.$inject = ['$window', '$scope', '$http', '$stateParams', '$location', 'FoundationApi', 'CompanyService', 'EmailService', 'TriggerService', 'NotificationFactory']

  function emails ($window, $scope, $http, $stateParams, $location, FoundationApi, CompanyService, EmailService, TriggerService, NotificationFactory) {
    var vm = this

    vm.metadata = {}
    CompanyService.findForChannel({
      type: 'emails'
    }, function (data) {
      vm.company = data
      if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
        for (var i in vm.company.metadata) {
          if (typeof vm.company.metadata[i]['value'] === 'string') {
            vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value'])
          } else {
            vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value']
          }
        }
      }
      parseTriggers()
    })

    vm.addEmail = function () {
      vm.email = {
        company_id: vm.company.id
      }
      FoundationApi.publish('addEmailModal', 'open')
    }

    vm.editEmail = function (email) {
      vm.email = email
      FoundationApi.publish('addEmailModal', 'open')
    }

    vm.deleteEmail = function (email, index) {
      var confirmation = $window.confirm($scope.labels.removeEmailQuestion + email.inbound_email + ' ?')
      if (confirmation) {
        EmailService.delete({ id: email.id }, function (data) {
          vm.company.emails.splice(index, 1)
          FoundationApi.publish('notifications', { title: $scope.labels.removed, content: $scope.labels.sucRemoveData, autoclose: '3000', color: 'success' })
        })
      }
    }

    vm.saveEmail = function (email) {
      vm.email = email
      vm.email.outbound_email = vm.email.outbound_data.user
      if (vm.email.id === undefined) {
        EmailService.create({},
          vm.email,
          function (data) {
            vm.company.emails.push(data)
            FoundationApi.publish('notifications', { title: $scope.labels.saved, content: $scope.labels.sucSaveData, autoclose: '3000', color: 'success' })
            FoundationApi.publish('addEmailModal', 'close')
          },
          function (error) {
            var message = $scope.labels.errorProcessReq
            if (error) {
              if (error.data) {
                if (error.data.message) message = error.data.message
              }
            }
            FoundationApi.publish('notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' })
          })
      } else {
        EmailService.update({ id: vm.email.id }, vm.email, function (data) {
          // Save email trigger
          vm.saveOfflineMessage(vm.email)

          FoundationApi.publish('notifications', {
            title: $scope.labels.saved, content: 'Os dados foram atualizados com sucesso!', autoclose: '3000', color: 'success'
          })
        }, function (error) {
          var message = $scope.labels.errorProcessReq
          if (error) {
            if (error.data) {
              if (error.data.message) message = error.data.message
            }
          }

          FoundationApi.publish('notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' })
        })
      }
    }

    function parseTriggers () {
      vm.company.emails.forEach(
        function (email, indexEmail, collection) {
          if (email.triggers.length > 0) {
            email.triggers.forEach(
              function (trigger, indexTrigger, collectionTrigger) {
                if (trigger.trigger_type === 'offline_operators_notification') {
                  vm.company.emails[indexEmail].trigger_offline = {}
                  vm.company.emails[indexEmail].trigger_offline.params = {}
                  if (!trigger.hasOwnProperty('params') || trigger.params == null) {
                    vm.company.emails[indexEmail].trigger_offline.params = { active: true }
                  } else {
                    trigger.params = JSON.parse(trigger.params)
                    if (!trigger.params.hasOwnProperty('active')) {
                      vm.company.emails[indexEmail].trigger_offline.params.active = true
                    } else {
                      vm.company.emails[indexEmail].trigger_offline.params = trigger.params
                    }
                  }

                  var jsonActions = JSON.parse(vm.company.emails[indexEmail].triggers[indexTrigger].actions)
                  vm.company.emails[indexEmail].trigger_offline.text = jsonActions[0].params.text
                }
              })
          } else {
            vm.company.emails[indexEmail].trigger_offline = { text: '', params: { active: true } }
          }
        })
    }

    vm.saveOfflineMessage = function (email) {
      TriggerService.saveOthers({
        op: 'save-triggers-others', type: 'email', id: email.id
      }, {
        offline_operators_notification: email.trigger_offline
      }, function (resp) {},
      function (error) {
        console.log(error)
        FoundationApi.publish('notifications', { title: $scope.labels.error, content: $scope.labels.errorSaveTriggers, autoclose: '3000', color: 'alert' })
      })
    }
  }
// eslint-disable-next-line semi
})();
